import type { CSSProperties } from "react";
import type { ImageBackgroundPropsByStyle } from "./types";
import { cn } from "@/lib/utils";
import { DEFAULT_GAP, DEFAULT_PADDING, DEFAULT_POSITION } from "./lib";

export const ImageBackground = ({
  src,
  gap = DEFAULT_GAP,
  padding = DEFAULT_PADDING,
  style,
  position = DEFAULT_POSITION,
  children,
  className,
}: ImageBackgroundPropsByStyle<CSSProperties>) => {
  const backgroundImageStyle: CSSProperties = {
    backgroundImage: `url(${src})`,
    backgroundSize: "cover",
    backgroundPosition: position,
    backgroundRepeat: "no-repeat",
    ...style,
  };
  return (
    <div
      className={cn("relative rounded-none md:rounded-xl", className)}
      style={backgroundImageStyle}
    >
      <div className="flex flex-col" style={{ gap: gap, padding: padding }}>
        {children}
      </div>
    </div>
  );
};
